import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { sortAssetGroupsByPriority } from '@alfa-bank/site-invest-emitents-common/helpers';

import { dataTestId } from '../../config';

import type { TAssetGroupLabel } from './models';
import { IconAssetGroup } from './icon-asset-group';

export const AssetGroupLabel: FC<TAssetGroupLabel> = ({ Text, assetGroups, hasIcon, styles }) => {
    if (!assetGroups?.length) {
        return null;
    }

    const [firstGroup] = sortAssetGroupsByPriority(assetGroups);

    return (
        <span className={styles.assetGroupLabel}>
            <Text
                dataTestId={dataTestId.label}
                kind="primaryInverted"
                styler={{ margin: 0, padding: 4 }}
                tag="span"
                view="accent-secondary-small"
            >
                {hasIcon && <IconAssetGroup className={cn(styles.external, styles.icon)} />}
                {firstGroup.code}
            </Text>
        </span>
    );
};
